export default "__VITE_ASSET__CPERsWO2__"